import { error } from '@services/toast-service'

export function validateEmail (email: string) {
  // eslint-disable-next-line max-len
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

/**
 * Minimum eight characters, at least one letter, one number and one special character:
 *
 * @see https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a
 * @param password
 * @returns
 */
export function validatePassword (password: string) {
  // eslint-disable-next-line max-len
  const re = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/
  return re.test(password)
}

const getErrorMsg = (inputs: NodeListOf<HTMLInputElement | HTMLTextAreaElement>) => {
  let err = ''
  let errEmail = ''
  let count = 0
  inputs.forEach(input => {
    if (!input.value) {
      err += `${input.name}${count > 0 ? ',' : ''} `
      count += 1
    }
    if (input.type === 'email' && !validateEmail(input.value)) {
      errEmail += 'Invalid email'
    }
  })
  return { err, errEmail }
}

export const isInputRequired = () => {
  const inputs = document.querySelectorAll('input[required]') as NodeListOf<HTMLInputElement>
  const textArea = document.querySelectorAll('textarea[required]') as NodeListOf<HTMLTextAreaElement>
  let isError = false

  const { err, errEmail } = getErrorMsg(inputs)
  const { err: errMsgTxtArea } = getErrorMsg(textArea)

  if (err) {
    error(`${err} is required`)
    isError = true
  }

  if (errMsgTxtArea) {
    error(`${errMsgTxtArea} is required`)
    isError = true
  }

  if (errEmail) {
    error(errEmail)
    isError = true
  }
  return isError
}

export function validateIPaddress (inputText: string) {
  // eslint-disable-next-line max-len
  const ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
  if (inputText.match(ipformat)) {
    return true
  }
  return false
}
